var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutVertCouv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3,9.6h0.9v8.4l0.1,0.2l1.3,0.1V19H9.9v-0.7l1.4-0.1l0.2-0.3v-6.7l-0.1-0.2l-2,0.3v-0.7L12.3,9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8h-4.8c-0.6-1.8-2.6-2.7-4.4-2.1C9.9,1,9.1,1.8,8.8,2.8H4c-1.3,0-2.3,1-2.3,2.3v16.1c0,1.3,1,2.3,2.3,2.3h16.1 c1.3,0,2.3-1,2.3-2.3V5.1C22.4,3.8,21.4,2.8,20,2.8 M12.1,2.8c0.6,0.1,1.1,0.6,1,1.2s-0.6,1.1-1.2,1c-0.6-0.1-1-0.5-1-1.1 c0-0.6,0.5-1.2,1.1-1.2c0,0,0,0,0.1,0 M6.3,7.4h11.5V5.1H20v16.1H4V5.1h2.3L6.3,7.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutVertCouv);
export default __webpack_public_path__ + "static/media/statut_vert_couv.c0fb6d00.svg";
export { ForwardRef as ReactComponent };